import { render, staticRenderFns } from "./completed-delivery.vue?vue&type=template&id=876a3e70"
import script from "./completed-delivery.vue?vue&type=script&lang=js"
export * from "./completed-delivery.vue?vue&type=script&lang=js"
import style0 from "./completed-delivery.vue?vue&type=style&index=0&id=876a3e70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports